<!--
 * @Descripttion:
 * @version:
 * @Author: 夏春雨
 * @Date: 2021-09-28 08:19:26
 * @LastEditors: 夏春雨
 * @LastEditTime: 2022-02-15 09:45:49
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  destroyed(){
    alert("关闭vue");
  }
}
</script>

<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  width: 0px;
  background: rgba(16, 31, 28, .1);
  -webkit-border-radius: 1em;
  -moz-border-radius: 1em;
  border-radius: 1em;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(144,147,153,.5);
  background-clip: padding-box;
  min-height: 50px;
  -webkit-border-radius: 1em;
  -moz-border-radius: 1em;
  border-radius: 1em;
  transition: background-color .3s;
  cursor: pointer;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144,147,153,.3);
}
</style>



// WEBPACK FOOTER //
// src/App.vue